import { PrescriptionOperationFault } from '@dreryk/egabinet-prescription-frontend-api';
import {
   VisitPrescriptionAnnulmentSendCommand,
   VisitPrescriptionPackageQuery,
} from '@dreryk/egabinet-visit-frontend-api';

import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { CertificateFault, useCertificateFaultHandlerMap } from '~libs.desktop.shared.account';

import { annulledPrescriptionsTranslationKeys } from '../../../../../translations';

type SentPrescriptionAnnulmentCommandRenderer = (renderProps: {
   sentPrescriptionAnnulment: () => Promise<void>;
}) => JSX.Element;

type SentPrescriptionAnnulmentCommandProps = {
   children: SentPrescriptionAnnulmentCommandRenderer;
   onAuthenticationRequiredFault: VoidFunction;
   onPrescriptionOperationFault: (errorMessage: string | null) => void;
   prescriptionId: string;
   visitId: number;
};

export const SentPrescriptionAnnulmentCommand = (props: SentPrescriptionAnnulmentCommandProps): JSX.Element => {
   const { executeAsync: prescriptionAnnulment } = useCqrsCommand<
      void,
      void,
      CertificateFault | PrescriptionOperationFault
   >(
      () => {
         const command = new VisitPrescriptionAnnulmentSendCommand();
         command.visitId = props.visitId;
         command.prescriptionId = Number(props.prescriptionId);
         return command;
      },
      {
         onSuccess: async () => {
            await refetchCqrsQuery(VisitPrescriptionPackageQuery);
            dispatchSnackbarPositiveEvent(annulledPrescriptionsTranslationKeys.prescriptionAnnulled);
         },
         onFault: {
            ...useCertificateFaultHandlerMap({
               onAuthenticationRequired: props.onAuthenticationRequiredFault,
            }),
            'egabinet-prescription-frontend-api:PrescriptionOperationFault': ({ errorMessage }) => {
               dispatchSnackbarNegativeEvent(annulledPrescriptionsTranslationKeys.prescriptionNotAnnulled);
               props.onPrescriptionOperationFault(errorMessage ?? null);
            },
         },
         onUnexpectedError: () =>
            dispatchSnackbarNegativeEvent(annulledPrescriptionsTranslationKeys.prescriptionNotAnnulled),
      }
   );

   return props.children({
      sentPrescriptionAnnulment: prescriptionAnnulment,
   });
};
